import submitCommand from '../../../services/submitCommand';
import { Supply } from '../models/timeline';

export const createSectionCustomization = (
  customizationId: string,
  timelineId: string,
  customization: {
    customizationType: 'text' | 'supplies';
    segmentID: string;
    sectionID: string;
    text?: string;
    supplies?: Supply[];
  },
  orgId: string,
  initiatingUserId: string
) => {
  return submitCommand(
    customizationId,
    {
      customizationID: customizationId,
      timelineID: timelineId,
      orgID: { id: orgId },
      sectionCustomization: customization,
      initiatingUserID: initiatingUserId,
    },
    'TcCreateSectionCustomization',
    'TcSectionCustomizationCreated',
    'TcSectionCustomizationFailed'
  );
};
